/**
 * @file schemas/staff-lookups.ts
 * @description 員工字典 Zod 校驗 schema（服務部門 / 職稱 / 聘用職務）。
 *
 * 各字典共用同一套基礎欄位（description / sortOrder / isActive），
 * 由 lookupBaseShape 衍生出各組 create/update schema，
 * 與 client-lookups.ts 的 createContractSourceSchema 寫法完全同構。
 */
import { z } from 'zod';
/** 字典共用欄位（除 name 外），create 用。 */
const lookupBaseShape = {
    description: z.string().max(500).optional().nullable(),
    sortOrder: z.number().int().min(0).default(0),
    isActive: z.boolean().default(true),
};
// ---------- 服務部門 departments ----------
/**
 * 服務部門字典新增 schema（對應 departments 表）。
 * 例如「管理組」「驗證組」「服務組」。
 */
export const createDepartmentSchema = z.object({
    name: z.string().min(1).max(50),
    ...lookupBaseShape,
});
export const updateDepartmentSchema = createDepartmentSchema.partial();
// ---------- 職稱 job_titles ----------
/**
 * 職稱字典新增 schema（對應 job_titles 表）。
 * 例如「董事長」「總經理」「管理者代表」「軟體工程師」。
 */
export const createJobTitleSchema = z.object({
    name: z.string().min(1).max(50),
    ...lookupBaseShape,
});
export const updateJobTitleSchema = createJobTitleSchema.partial();
// ---------- 聘用職務 job_functions ----------
/**
 * 聘用職務字典新增 schema（對應 job_functions 表）。
 * 例如「稽核員」「資深稽核員」「稽核組長」「審議人員」「技術專家」。
 */
export const createJobFunctionSchema = z.object({
    name: z.string().min(1).max(50),
    ...lookupBaseShape,
});
export const updateJobFunctionSchema = createJobFunctionSchema.partial();
